import ArcTheme from "@Components/ArcTheme";
import store from "@ReduxStore/store";
import I18nLoader from "@Src/components/Translation";
import React from "react";
import { Provider } from "react-redux";
import InitApp from "@Src/components/InitApp";
import Routes from "./routes";

export default () => (
  <Provider store={store}>
    <InitApp>
      <I18nLoader>
        <ArcTheme>
          <Routes />
        </ArcTheme>
      </I18nLoader>
    </InitApp>
  </Provider>
);
